import React, { useState } from "react";
import { useLanguage } from "../Translations/LenguageContext";
import { useNavigate } from "react-router-dom";
import { MdTune } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import NewFineTuneModal from "./NewFineTuneModa";

const MainFineTune = ({
    account_id
}) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(false)
    const [data, setData] = useState([])

    const fetchRecords = async () => {

    }

    return (
        <div className="mainframe_item" >
            <div className="mainframe_item_header" >
                <p className="mainframe_item_title fade-in">{t.finetune.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {data.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>{t.finetune.empty_subtitle}</p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><MdTune /></i> {t.finetune.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">{t.finetune.quest_answ}</p>
                            </div>
                        </div>
                    ) : (
                        <p>{t.finetune.subtitle}</p>
                    )}
                </div>
                {/* <button
                    className={`mainframe_item_create_btn fade-in ${data.length === 0 && "mainframe_item_create_btn_anim"}`}
                    onClick={() => setOpenModal(true)}
                >
                    <BiPlus /> {t.create}
                </button> */}
                <p className="soon_av">Soon available</p>

            </div>
            <NewFineTuneModal
                account_id={account_id}
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchRecords}
            />
        </div >
    )
}

export default MainFineTune